import React from "react";

import { Route, Routes, useParams } from "react-router-dom";

import { withProjectRedirect } from "Hocs/withProjectRedirect";

import Configure from "./Configure/Page";
import Details from "./Details/Page";
import List from "./List/Page";
import Setup from "./Setup/Page";

const ProjectIntegrationRoutes = () => (
  <Routes>
    <Route path="setup/*" element={<Setup />} />
    <Route path=":integrationId/*">
      <Route path="log/:activityId" element={<Details />} />
      <Route
        path="configure"
        Component={function ConfigureIntegration() {
          const { integrationId, organizationId, projectId } = useParams();
          if (!integrationId || !organizationId || !projectId) return null;
          return (
            <Configure
              integrationId={integrationId}
              organizationId={organizationId}
              projectId={projectId}
            />
          );
        }}
      />
      <Route path="" element={<Details />} />
    </Route>
    <Route path="" element={<List />} />
  </Routes>
);
export default withProjectRedirect(ProjectIntegrationRoutes);
